import { render } from "./gridComponent.vue?vue&type=template&id=70bb5254"
import script from "./gridComponent.vue?vue&type=script&lang=js"
export * from "./gridComponent.vue?vue&type=script&lang=js"

import "./gridComponent.vue?vue&type=style&index=0&id=70bb5254&lang=css"

import exportComponent from "C:\\ClusterTrade\\NXM_CLUSTERTRADE\\nxm_clustertrade_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__